import { useState, useEffect } from "react";
import MessageError from "../../messages/messageError";
import api from "../../services/api";
import { useSelector } from "react-redux";
import MessageSuccess from "../../messages/messageSuccess";
import FazerObservacoes from "../components/fazerObservacoes.";
import ButtonLeft from "../../utils/buttonLeft";

export default function ChangeStatusAdmin({ admin, setHandleUpdate }) {
  const [messageSuccess, setMessageSuccess] = useState("");
  const [messageError, setErrorMessage] = useState("");
  const [status, setStatus] = useState(admin?.status);
  const [funcao, setFuncao] = useState(admin?.funcao ?? "");
  const [perfils, setPerfils] = useState([]);
  const [loadStatus, setLoadStatus] = useState(false);
  const [loadFuncao, setLoadFuncao] = useState(false);
  const user = useSelector((state) => state.account.user);
  const [obsStatus, setObsStatus] = useState("");

  useEffect(() => {
    api.get("/perfils")
      .then((res) => setPerfils(res.data.perfils ?? []))
      .catch(() => { });
  }, []);

  async function changeStatusAdmin() {
    setLoadStatus(true);
    setErrorMessage("");
    setMessageSuccess("");
    await api
      .patch("/admin/change-status", { status, adminId: admin._id, userId: user._id, descricao: obsStatus })
      .then((response) => {
        setLoadStatus(false);
        setMessageSuccess(response?.data.msg);
        setHandleUpdate(response.data);
      })
      .catch((error) => {
        setErrorMessage(error.response?.data.message);
        setLoadStatus(false);
      });
  }

  async function changeFuncaoAdmin() {
    setLoadFuncao(true);
    setErrorMessage("");
    setMessageSuccess("");
    await api
      .patch("/admin/change-funcao", { funcao, adminId: admin._id, userId: user._id })
      .then((response) => {
        setLoadFuncao(false);
        setMessageSuccess(response?.data.msg);
        setHandleUpdate(response.data);
      })
      .catch((error) => {
        setErrorMessage(error.response?.data.message);
        setLoadFuncao(false);
      });
  }

  const statusChanged = status !== admin?.status;
  const funcaoChanged = funcao !== (admin?.funcao ?? "");
  const isActivo = admin?.status === "Activo";

  return (
    <div className="tw-flex tw-flex-col  tw-p-1 tw-border tw-border-1 ">

      {messageSuccess && <MessageSuccess message={messageSuccess} />}
      {messageError && <MessageError message={messageError} />}

      {/* Secção Estado */}
      <div className="tw-rounded-xl tw-border tw-border-gray-200 tw-overflow-hidden">
        <div className="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-3 tw-bg-gray-50 tw-border-b tw-border-gray-200">
          <span className={`tw-w-2 tw-h-2 tw-rounded-full tw-flex-shrink-0 ${isActivo ? 'tw-bg-green-500' : 'tw-bg-red-500'}`} />
          <span className="tw-text-sm tw-font-semibold tw-text-gray-700">Estado do Funcionário</span>
          <span className={`tw-ml-auto tw-text-xs tw-font-semibold tw-px-2 tw-py-0.5 tw-rounded-full ${isActivo ? 'tw-bg-green-100 tw-text-green-700' : 'tw-bg-red-100 tw-text-red-600'}`}>
            {admin?.status}
          </span>
        </div>

        <div className="tw-p-4 tw-flex tw-flex-col tw-gap-3">
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="tw-w-full tw-border tw-border-gray-300 tw-rounded-lg tw-px-3 tw-py-2 tw-text-sm tw-text-gray-700 tw-bg-white focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-[#85287e]/40 focus:tw-border-[#85287e] tw-transition"
          >
            <option value="Activo">Activo</option>
            <option value="Inactivo">Inactivo</option>
          </select>

          {statusChanged && (
            <>
              <FazerObservacoes observacao={obsStatus} setObs={setObsStatus} obs={obsStatus} titulo="(Descreve aqui os motivos)" />
              <ButtonLeft funcao={changeStatusAdmin} title="Guardar Estado" load={loadStatus} disabled={loadStatus || !status} />
            </>
          )}
        </div>
      </div>

      {/* <hr className="tw-border-gray-200" /> */}

      {/* Secção Função */}
      <div className="tw-rounded-xl tw-border tw-border-gray-200 tw-overflow-hidden">
        <div className="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-3 tw-bg-gray-50 tw-border-b tw-border-gray-200">
          <svg className="tw-w-4 tw-h-4 tw-text-[#85287e] tw-flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
          </svg>
          <span className="tw-text-sm tw-font-semibold tw-text-gray-700">Função / Perfil</span>
          {admin?.funcao && (
            <span className="tw-ml-auto tw-text-xs tw-font-semibold tw-px-2 tw-py-0.5 tw-rounded-full tw-bg-purple-100 tw-text-[#85287e]">
              {admin.funcao}
            </span>
          )}
        </div>

        <div className="tw-p-4 tw-flex tw-flex-col tw-gap-3">
          <select
            value={funcao}
            onChange={(e) => setFuncao(e.target.value)}
            className="tw-w-full tw-border tw-border-gray-300 tw-rounded-lg tw-px-3 tw-py-2 tw-text-sm tw-text-gray-700 tw-bg-white focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-[#85287e]/40 focus:tw-border-[#85287e] tw-transition"
          >
            <option value="" disabled>Selecione uma função</option>
            {perfils.map((p) => (
              <option key={p._id} value={p.perfil}>{p.designacao}</option>
            ))}
          </select>

          {funcaoChanged && (
            <>
              {/* <FazerObservacoes observacao={obsFuncao} setObs={setObsFuncao} obs={obsFuncao} titulo="(Descreve aqui os motivos)" /> */}
              <ButtonLeft funcao={changeFuncaoAdmin} title="Guardar Função" load={loadFuncao} disabled={loadFuncao || !funcao} >
              </ButtonLeft>
            </>
          )}

        </div>
      </div>

    </div>
  );
}
